import { BaseModel } from './BaseModel';

export class Application extends BaseModel {
  static get entity() {
    return 'applications';
  }

  static get fk() {
    return 'application_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      user: this.attr(null),
      learning_unit: this.attr(null),
      mode: this.attr(null),
      evidenceSubmission: this.attr(null),
      percent: this.attr(null),
      status: this.attr(null),
      remaining_submission: this.attr(null)
    };
  }

  get isModeVerify() {
    return this.mode === 'VERIFY';
  }

  get isModeLearnVerify() {
    return this.mode === 'LEARN_VERIFY';
  }

  static apiConfig = {
    actions: {
      find(params = {}) {
        return this.get('/applications', { params: params });
      },

      count(params = {}) {
        return this.get('/applications/count', { params, save: false });
      },

      getDashboard(params = {}) {
        return this.get('/applications/dashboard', { params: params });
      },
      /* TODO: change to use custom route */
      create(userId, learningUnitId) {
        return this.post('/applications', {
          user: userId,
          learning_unit: learningUnitId
        });
      }
    }
  };
}

export default Application;
